module.exports = __webpack_public_path__ + "asset/image-iconCategorySubscription-426c982fa69e5e75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategorySubscription.svg
// module id = hNRh
// module chunks = 0